import { SearchOutlined } from "@ant-design/icons";
import { Card, Col, message, Row, Spin } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BUTTON_SIZE, INPUT_SIZE } from "../../../common/ThemeConstants";
import FormButton from "../../../components/general/FormButton";
import FormContainer from "../../../components/general/FormContainer";
import FormSelect from "../../../components/general/FormSelect";
import FormTextField from "../../../components/general/FormTextField";
import ReportExcelDownload from "../../../components/ReportingComponents/ReportExcelDownload";
import { postRequest } from "../../../services/mainApp.service";
import DailySaleTemp from "./DailySaleTemp";

const DailySaleReport = () => {
  const userData = useSelector((state) => state.authReducer);
  const [disableExcel, setDisableExcel] = useState(true);
  const [reportType] = useState([
    {
      name: "Business Day Single",
      id: 1,
    },
    {
      name: "Shift",
      id: 2,
    },
    {
      name: "Terminal",
      id: 3,
    },
  ]);
  const [data, setData] = useState({
    ReportTypeId: 1,
    BranchId: null,
    DateFrom: null,
    DateTo: null,
    BusinessDayId: null,
    ShiftId: null,
    TerminalId: null,
    PaymentModeId: null
  });

  const [reportData, setReportData] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [terminalList, setTerminalList] = useState([]);
  const [paymentModeList, setPaymentModeList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const ctrl = new AbortController();
    postRequest(
      "DSRReport",
      {
        OperationId: 0,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
        BranchId: data.BranchId,
        DateFrom: data.DateFrom,
        DateTo: data.DateTo,
        BusinessDayId: null,
        ShiftId: null,
        TerminalId: null,
      },
      ctrl
    )
      .then((res) => {
        if (res.error) {
          message.error(res.errorMessage || "Failed to load filters");
          return;
        }
        const ds = res.data?.DataSet || {};
        setBranchList(ds.Table || []);
        setShiftList(ds.Table1 || []);
        setTerminalList(ds.Table2 || []);
        setPaymentModeList(ds.Table3 || []);
      })
      .catch(() => {
        message.error("Failed to load filters");
      });

    return () => ctrl.abort();
  }, [
    data.BranchId,
    data.DateFrom,
    data.DateTo,
    userData.CompanyId,
    userData.UserId,
  ]);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setLoading(true);
    if (data.DateFrom !== "" && data.DateTo !== "") {
      if (new Date(data.DateFrom) <= new Date(data.DateTo)) {
        if (data.ReportTypeId == null || data.ReportTypeId === "") {
          setLoading(false);
          message.error("Please select Report Type");
          return;
        }
        if (data.ReportTypeId === 2 && !data.ShiftId) {
          setLoading(false);
          message.error("Please select Shift");
          return;
        }
        if (data.ReportTypeId === 3 && !data.TerminalId) {
          setLoading(false);
          message.error("Please select Terminal");
          return;
        }
        postRequest("DSRReport", {
          ...data,
          OperationId: 1,
          CompanyId: userData.CompanyId,
          UserId: userData.UserId,
        })
          .then((res) => {
            setLoading(false);
            if (res.error) {
              message.error(res.errorMessage || "Request failed");
              return;
            }
            if (!res.data.DataSet.Table.length) {
              message.error("Records not found!");
              return;
            }
            setReportData(res.data.DataSet.Table);
            setDisableExcel(false);
          })
          .catch(() => {
            setLoading(false);
            message.error("Request failed");
          });
      } else {
        setLoading(false);
        message.error("Please select DateTo greater than DateFrom");
      }
    } else {
      setLoading(false);
      message.error("Please select both dates");
    }
  };

  const fieldPanel = (
    <FormContainer rowStyle={{ alignItems: "flex-end" }} onSubmit={handleSearchSubmit}>
      <Col span={24}>
        <Row gutter={10} style={{ alignItems: "self-end" }}>
          <FormSelect
            listItem={branchList || []}
            colSpan={4}
            idName="BranchId"
            valueName="BranchName"
            size={INPUT_SIZE}
            name="BranchId"
            className="textInput"
            label="Branches"
            value={data.BranchId || ""}
            onChange={(e) => {
              setData({
                ...data,
                BranchId: e.value,
                ShiftId: null,
                TerminalId: null,
                PaymentModeId: null,
              });
              setReportData([]);
            }}
            required={true}
          />
          <Col span={4}>
            <div>Date From</div>
            <FormTextField
              type="date"
              style={{ width: "100%" }}
              value={data.DateFrom}
              onChange={(e) =>
                setData({
                  ...data,
                  DateFrom: e.value,
                  ShiftId: null,
                  TerminalId: null,
                  PaymentModeId: null,
                })
              }
            />
          </Col>
          <Col span={4}>
            <div>Date To</div>
            <FormTextField
              type="date"
              style={{ width: "100%" }}
              value={data.DateTo}
              onChange={(e) =>
                setData({
                  ...data,
                  DateTo: e.value,
                  ShiftId: null,
                  TerminalId: null,
                  PaymentModeId: null,
                })
              }
            />
          </Col>
          <FormSelect
            listItem={reportType || []}
            colSpan={4}
            idName="id"
            valueName="name"
            size={INPUT_SIZE}
            name="ReportTypeId"
            className="textInput"
            label="Report Type"
            value={data.ReportTypeId}
            onChange={(e) =>
              setData({
                ...data,
                ReportTypeId: e.value,
                ShiftId: null,
                TerminalId: null,
                PaymentModeId: null,
              })
            }
            required={true}
          />
          {data.ReportTypeId === 2 && (
            <FormSelect
              listItem={shiftList || []}
              colSpan={4}
              idName="ShiftId"
              valueName="ShiftName"
              size={INPUT_SIZE}
              name="ShiftId"
              className="textInput"
              label="Shift"
              value={data.ShiftId || ""}
              onChange={(e) => {
                setData({ ...data, ShiftId: e.value });
                setReportData([]);
              }}
              required={true}
            />
          )}
          {data.ReportTypeId === 3 && (
            <FormSelect
              listItem={terminalList || []}
              colSpan={4}
              idName="TerminalId"
              valueName="TerminalName"
              size={INPUT_SIZE}
              name="TerminalId"
              className="textInput"
              label="Terminal"
              value={data.TerminalId || ""}
              onChange={(e) => {
                setData({ ...data, TerminalId: e.value });
                setReportData([]);
              }}
              required={true}
            />
          )}
          <FormSelect
            listItem={paymentModeList || []}
            colSpan={4}
            idName="PaymentModeId"
            valueName="PaymentMode"
            size={INPUT_SIZE}
            name="PaymentModeId"
            className="textInput"
            label="Payment Mode"
            value={data.PaymentModeId ?? ""}
            onChange={(e) => {
              setData({ ...data, PaymentModeId: e.value });
              setReportData([]);
            }}
          />
          <Col span={2}>
            <FormButton
              title="Search"
              type="primary"
              size={BUTTON_SIZE}
              htmlType="submit"
              icon={<SearchOutlined />}
            />
          </Col>
        </Row>
      </Col>
    </FormContainer>
  );

  const selectedPaymentModeName =
    data.PaymentModeId != null && data.PaymentModeId !== ""
      ? paymentModeList?.find(
          (x) => String(x.PaymentModeId) === String(data.PaymentModeId)
        )?.PaymentMode
      : null;
  const reportTitle = selectedPaymentModeName
    ? `Daily Sale Report - ${selectedPaymentModeName}`
    : "Daily Sale Report";

  return (
    <div style={{ background: "white", padding: 20 }}>
      <h1 style={{ color: "#017971", fontSize: 28 }}>
        <b>{reportTitle}</b>
      </h1>

      <Card>
        <Row>
          <Col span={24}>{fieldPanel}</Col>
        </Row>
      </Card>

      <ReportExcelDownload
        fileName={`${reportTitle} ${data.DateFrom} - ${data.DateTo}`}
      // hidePdf={1}
      >
        {loading && (
          <Spin
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          />
        )}
        {reportData?.length > 0 && (
          <DailySaleTemp
            list={reportData}
            reportTitle={reportTitle}
            branchName={
              branchList?.find((x) => x.BranchId === data.BranchId)?.BranchName
            }
            headList={reportData.length > 0 ? Object.keys(reportData[0]) : []}
            date={`Date Range: ${data.DateFrom} to ${data.DateTo}`}
          />
        )}
      </ReportExcelDownload>
    </div>
  );
};

export default DailySaleReport;
